'use client'

import type { ChildrenProps } from '@snowball-tech/common/types'

import useTranslations from '@snowball-tech/common/hooks/useTranslations'
import { Button } from '@snowball-tech/fractal/dist/src/components/Button'
import { Dialog } from '@snowball-tech/fractal/dist/src/components/Dialog'
import { Typography } from '@snowball-tech/fractal/dist/src/components/Typography'
import dynamicImport from 'next/dynamic'

import { useState } from 'react'

import SubscribeForm from '../Home/SubscribeForm'

const Confettis = dynamicImport(() => import('@/components/Home/Confettis'), {
  ssr: false,
})

type Props = {
  className?: string
} & Partial<ChildrenProps>
export default function SubscribeDialog({
  children: trigger,
  className,
}: Props) {
  const $t = useTranslations()

  const [isSubscribeSubmitted, setIsSubscribeSubmitted] = useState(false)

  return (
    <>
      <Confettis />

      <Dialog
        className="max-w-[576px] p-3 sm:min-w-[368px]"
        closeButtonLabel={$t('general.close')}
        overlayStyle="dark"
        position="absolute"
        title={$t(
          isSubscribeSubmitted
            ? 'subscribe.title.submitted'
            : 'home.hero.subscribe.title',
        )}
        trigger={
          trigger ?? (
            <Button
              className={className}
              label={$t('header.signup.label')}
              variant="display"
            />
          )
        }
        onClose={() => setIsSubscribeSubmitted(false)}
      >
        {!isSubscribeSubmitted && (
          <Typography>{$t('home.hero.subscribe.description')}</Typography>
        )}

        <SubscribeForm
          origin="header"
          onSubmit={() => setIsSubscribeSubmitted(true)}
        />
      </Dialog>
    </>
  )
}
